export const QUERY_KEY_ORDER = [
  'language',
  'sort',
  'brands',
  'min-price',
  'max-price',
  'others',
  'q',
]
